import { defineStore } from 'pinia';

const state = defineStore('menu', {
  state: () => ({
    quiz: false,
    planner: false,
  }),
});

export default state;
